// R40 (scan R-S2-027): contract notes can be written by the AI assistant or imported, so they
// are shown as text only, never inserted as HTML. Older notes that carry markup are reduced to
// their text by an inert parser: a DOMParser document has no browsing context, so no script
// runs and nothing loads. Line breaks and paragraph ends become new lines.
const notesText = (value) => {
  if (value === null || value === undefined) return "";
  const marked = String(value)
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/(p|div|li|h[1-6])\s*>/gi, "\n");
  const doc = new DOMParser().parseFromString(marked, "text/html");
  // Code and style blocks are not note text.
  doc.querySelectorAll("script,style,template").forEach((node) => node.remove());
  const text = doc.body.textContent || "";
  return text.replace(/\n{3,}/g, "\n\n").trim();
};

export default notesText;
